import React, { useState, useEffect } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import { getDivisions, deleteDivision, saveDivision, addDivision } from '../../API';
import DivisionCard from '../Division/DivisionCard';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function Lookups(props) {
    const [lookup, setLookup] = useState('divisions');
    const [divisions, setDivisions] = useState([]);
    const [newDivisions, setNewDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(false);

    useEffect(() => {
        fetchDivisions();
    }, []);

    const fetchDivisions = async () => {
        try {
            setIsLoadingDivisions(true);
            const divisionsResult = await getDivisions();
            setDivisions(divisionsResult.map(d => { return { ...d, isEditing: false }; }));
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsLoadingDivisions(false);
        }
    };

    const getNewDivisionID = () => {
        return newDivisions.map(d => d.divisionID).reduce((a, b) => (a < b) ? a : b, 0) - 1;
    };

    const addNewDivision = async () => {
        const newDivision = {
            divisionID: getNewDivisionID(),
            isEditing: true,
        };
        setNewDivisions([newDivision, ...newDivisions]);
    };

    const updateNewDivision = (divisionID, e) => {
        const updatedDivisions = [...newDivisions];
        const updateIndex = updatedDivisions.findIndex(d => d.divisionID === divisionID);
        updatedDivisions[updateIndex] = { ...updatedDivisions[updateIndex], [e.target.name]: e.target.value };
        setNewDivisions(updatedDivisions);
    };

    const cancelNewDivision = (divisionID) => {
        setNewDivisions(newDivisions.filter(nd => nd.divisionID !== divisionID));
    };

    const createDivision = async (division) => {
        try {
            const newDivision = { ...division };
            newDivision.divisionID = 0;
            await addDivision(newDivision);
            fetchDivisions();
            cancelNewDivision(division.divisionID);
        } catch (ex) {
            console.log(ex);
        }
    };

    const updateDivision = (divisionID, e) => {
        const updatedDivisions = [...divisions];
        const updateIndex = updatedDivisions.findIndex(d => d.divisionID === divisionID);
        updatedDivisions[updateIndex] = { ...updatedDivisions[updateIndex], [e.target.name]: e.target.value };
        setDivisions(updatedDivisions);
    };

    const editDivision = (divisionID) => {
        const updatedDivisions = [...divisions];
        const updateIndex = updatedDivisions.findIndex(d => d.divisionID === divisionID);
        updatedDivisions[updateIndex] = { ...updatedDivisions[updateIndex], isEditing: true };
        setDivisions(updatedDivisions);
    };

    const cancelDivision = (divisionID) => {
        const updatedDivisions = [...divisions];
        const updateIndex = updatedDivisions.findIndex(d => d.divisionID === divisionID);
        updatedDivisions[updateIndex] = { ...updatedDivisions[updateIndex], isEditing: false };
        setDivisions(updatedDivisions);
    };

    const commitDivision = async (division) => {
        try {
            console.log(division);
            await saveDivision(division);
            fetchDivisions();
        } catch (ex) {
            console.log(ex);
        }
    };

    const removeDivision = async (divisionID) => {
        try {
            if ([1, 2, 3].includes(divisionID)) {
                alert("Cannot delete this program.");
                return;
            }
            await deleteDivision(divisionID);
            fetchDivisions();
        } catch (ex) {
            console.log(ex);
        }
    };

    const newDivisionsJSX = newDivisions.map(d => {
        return (<DivisionCard key={d.divisionID} division={d} update={updateNewDivision} save={createDivision} cancel={cancelNewDivision} isEditing={true} />)
    });

    let divisionsJSX = null;
    if (isLoadingDivisions) {
        divisionsJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else {
        divisionsJSX = divisions.map(d => {
            return (<DivisionCard key={d.divisionID} division={d} update={updateDivision} save={commitDivision} cancel={cancelDivision} edit={editDivision} remove={removeDivision} isEditing={d.isEditing} />);
        });
    }

    return (
        <div id="lookups">
            <div onClick={addNewDivision} className="action-icon action-add float-right flex-end tooltip-parent">
                <i className="fas fa-plus"></i>
                <div className="tooltip-target">
                    Add Program
                </div>
            </div>
            <div className="new-divisions">
                {newDivisionsJSX}
            </div>
            <div className="divisions">
                {divisionsJSX}
            </div>
        </div>
    );
}

export default Lookups;